import type React from 'react'
import styled, { css, useTheme } from 'styled-components'

import { useSticky } from '@hooks'

import { AppBar } from '@components/ui'

const PlaceholderWrapper = styled.div`
  height: 132px;
`

// need to use mui appbar for preventing jumping on popover's scroll lock behavior
// this component listens on it and makes correction with padding
const StyledAppBar = styled(AppBar).attrs({ tag: 'div', noShadow: true })`
  padding: 0;
  background-color: transparent;

  ${({ position, theme }) =>
    position === 'fixed' &&
    css`
      top: calc(${theme.appBarHeightMedium}px + ${theme.newVersionBarOffset});
      border-bottom: 1px solid ${theme.colors.common.paperStroke};
      box-shadow: var(--filterBarBoxShadow, none);
      height: ${theme.stickyFilterBarHeight}px;
      transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    `}
`

export function StickyFilterBar({ children }: { children: (sticky: boolean) => React.ReactNode }) {
  const theme = useTheme()
  const [sticky, appBarRef] = useSticky(theme.appBarHeightMedium)
  return (
    <PlaceholderWrapper ref={appBarRef}>
      <StyledAppBar position={sticky ? 'fixed' : 'static'}>{children(sticky)}</StyledAppBar>
    </PlaceholderWrapper>
  )
}
